import React from "react";
import { BrowserRouter as Router, Route, Switch, Link } from "react-router-dom";
import Home from "./components/home";
import Login from "./components/login";
import About from "./components/about";
import Layout from "./components/layout";
import Product from "./components/product";
import Inquiry from "./components/inquiry";
import Contact from "./components/contact";
import ProductImage from "./components/productImage";
import "../src/public/assets/css/animate.css";
import "../src/public/assets/css/bootstrap.min.css";
import "../src/public/assets/css/font-awesome.min.css";
import "../src/public/assets/css/style.css";
import ProductDetail from "./components/productDetail";
import ProductByCategoryDetail from "./components/productByCategory";
import Cart from "./components/cart";
import Checkout from "./components/checkout";
import Wishlist from "./components/wishlist";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ProductForm from "./components/ProductForm";
import { FaWhatsapp } from "react-icons/fa";
import { FaQuestionCircle } from "react-icons/fa";
import ScrollToTop from "./components/ScrollToTop";

import ProductCatalogue from "./components/ProductCatalogue";

function App() {
  const whatsappNumber = "919662917174";

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000} // closes after 3 seconds
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <Router>
          <ScrollToTop />
        {/* Sticky Floating Buttons */}
        <div className="sticky-float-buttons">
          <a
            href={`https://wa.me/${whatsappNumber}?text=Hello! I'm interested in your products`}
            target="_blank"
            rel="noopener noreferrer"
            className="sticky-btn whatsapp-sticky"
            title="Chat on WhatsApp"
          >
            <FaWhatsapp size={24} />
            <span>WhatsApp</span>
          </a>
          <Link
            to="/inquiry"
            className="sticky-btn inquiry-sticky"
            title="Send Inquiry"
          >
            <FaQuestionCircle size={24} />
            <span>Inquiry</span>
          </Link>
        </div>

        <Switch>
          <Layout>
        
            <Route exact path="/" component={Home} />
            <Route exact path="/login" component={Login} />
            <Route path="/about" component={About} />
            <Route path="/product" component={Product} />
            <Route path="/cart" component={Cart} />
            <Route path="/wishlist" component={Wishlist} />
            <Route
              path="/product_by_category/:id"
              component={ProductByCategoryDetail}
            />
            <Route path="/product_detail/:id" component={ProductDetail} />
            <Route path="/contact_us" component={Contact} />
            <Route path="/product_images/:id/:name" component={ProductImage} />
            <Route path="/checkout" component={Checkout} />
            <Route path="/inquiry" component={Inquiry} />
            <Route path="/product-form" component={ProductForm} />

            <Route path="/product_catalogue/:id/:name" component={ProductCatalogue} />
          </Layout>
          {/* Optional: 404 route */}
          <Route path="*" render={() => <h1>404 - Not Found</h1>} />
        </Switch>
        {/* </Layout> */}
      </Router>
    </>
  );
}

export default App;
